import { Tooltip } from 'antd';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Empty } from 'antd';
import { TranslateString } from 'Utils/Common';
import CustomMap from 'components/shared/map/CustomMap';
import { useIntl } from 'react-intl';

const ExtLtvTableCard = (props: any) => {
    const targetRef: any = useRef();
    const [dimensions, setDimensions] = useState({ height: 0 });
    const [locationData, setLocationData] = useState();
    const intl = useIntl();
    useLayoutEffect(() => {
        if (targetRef.current) {
            setDimensions({
                height: targetRef.current.offsetHeight
            });
        }
    }, [props]);

    useLayoutEffect(() => {
        if (props?.cardTargetRef?.current) {
            props.setCardDimensions({
                height: props.cardTargetRef.current.offsetHeight
            });
        }
    }, [props]);

    useEffect(() => {
        let modifyArr = props?.tableData?.hsp_sales_data_location;
        modifyArr = modifyArr?.map((val: any) => {
            return { location: { lat: parseFloat(val?.lat), lng: parseFloat(val?.long) }, sale_data_num_rooms: val?.sale_data_num_rooms }
        });
        setLocationData(modifyArr);
    }, [props]);

    return (
        <>
            <Col sm={9} className=''>
                <div ref={props?.cardTargetRef}>
                    <div className="d-flex justify-content">
                        <div className="cu-bg-green mx-1 px-3 pt-1 rounded" style={{ width:"20%" }}>

                            {
                                (() => {
                                    if (props?.tableData?.customer_data?.buildyear_color === "red") {
                                        if (intl.locale === "fi") {
                                            return (
                                                <Tooltip title={(props?.tableData?.customer_data?.buildyear_msg_fin === 'Korjaa se järjestelmässä' ? 'Korjaa tieto järjestelmään' : props?.tableData?.customer_data?.buildyear_msg_fin) || ""} color={"#e45649"}>
                                                    <p className='cu-text-small fw-bold mb-1' style={{ color: "#e45649" }}>{TranslateString('Year of construction')}</p>
                                                    <p className='cu-text-large' style={{ color: "#e45649" }}>{props?.tableData?.customer_data?.cust_data_buildyear || ""}</p>
                                                </Tooltip>
                                            );
                                        } else {
                                            return (
                                                <Tooltip title={props?.tableData?.customer_data?.buildyear_msg_eng || ""} color={"#e45649"}>
                                                    <p className='cu-text-small fw-bold mb-1' style={{ color: "#e45649" }}>{TranslateString('Year of construction')}</p>
                                                    <p className='cu-text-large' style={{ color: "#e45649" }}>{props?.tableData?.customer_data?.cust_data_buildyear || ""}</p>
                                                </Tooltip>
                                            );
                                        }
                                    } else {
                                        return (
                                            <>
                                                <p className='cu-text-small fw-bold mb-1'>{TranslateString('Year of construction')}</p>
                                                <p className='cu-text-large'>{props?.tableData?.customer_data?.cust_data_buildyear || ""}</p>
                                            </>
                                        );
                                    }
                                })()
                            }

                        </div>
                        <div className="cu-bg-green mx-1 px-3 pt-1 rounded" style={{ width:"20%" }}>
                            <p className='cu-text-small fw-bold mb-1'>{TranslateString('Property type')}</p>
                            <p className='cu-text-large'>{props?.tableData?.customer_data?.cust_data_property_type_group || ""}</p>
                        </div>
                        <div className="cu-bg-green mx-1 px-3 pt-1 rounded" style={{ width:"20%" }}>
                            <p className='cu-text-small fw-bold mb-1'>{TranslateString('Plot')}</p>
                            <p className='cu-text-large'>{props?.tableData?.customer_data?.cust_data_ownership_type || ""}</p>
                        </div>
                        <div className="cu-bg-green mx-1 px-3 pt-1 rounded" style={{ width:"20%" }}>
                            <p className='cu-text-small fw-bold mb-1'>{TranslateString('Postal code')}</p>
                            <p className='cu-text-large'>{props?.tableData?.customer_data?.cust_data_zipcode || ""}</p>
                        </div>
                        <div className="cu-bg-green mx-1 px-3 pt-1 rounded" style={{ width:"20%" }}>
                            <p className='cu-text-small fw-bold mb-1'>{TranslateString('Street')}</p>
                            <p>{props?.tableData?.customer_data?.cust_data_streetaddress || ""}</p>
                        </div>
                    </div>
                    <div className='mt-3 cu-table-border'>
                        <table className="table table-sm table-bordered table-striped " >
                            <thead className="">
                                <tr className="">
                                    <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                        {TranslateString('Loans, indicative price estimate of the property and LTV')}
                                    </td>
                                </tr>
                                <tr className='cu-bg-green align-top cu-text-small text-left'>
                                    <th scope="col" className="fw-600">{TranslateString('Loan name')}</th>
                                    <th scope="col" className="text-right fw-600">{TranslateString('Remaining capital')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "15%" }}>{TranslateString('Average indicative price estimate')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "15%" }}>{TranslateString('Average indicative price (lower quartile)')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "15%" }}>{TranslateString('Average indicative price (upper quartile)')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "10%" }}>{TranslateString('LTV')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "10%" }}>{TranslateString('LTV Min')}</th>
                                    <th scope="col" className="text-right fw-600" style={{ width: "10%" }}>{TranslateString('LTV Max')}</th>
                                </tr>
                            </thead>
                            <tbody >
                                {props?.tableData?.loanData?.length > 0 ? props?.tableData?.loanData?.map((val: any) => {
                                    return (
                                        <tr className='cu-text-small text-left'>
                                            <td>{val.loan_data_name?.replace('Uusi laina:',TranslateString('new_loan')) || ""}</td>
                                            <td className="text-right">{val.loan_data_loan_value}</td>
                                            <td className="text-right">{val.indicative_price}</td>
                                            <td className="text-right">{val.quartile_25}</td>
                                            <td className="text-right">{val.quartile_75}</td>
                                            <td className="text-right">{val.ltv}</td>
                                            <td className="text-right">{val.ltv_min}</td>
                                            <td className="text-right">{val.ltv_max}</td>
                                        </tr>
                                    )
                                }) : <tr><td colSpan={7}><Empty description={TranslateString("Empty")} /></td></tr>}
                            </tbody>
                            <tfoot>
                                {props?.tableData?.loanData?.length > 0 && props?.tableData?.loanData_total ?
                                    <tr className='cu-text-small text-left fw-bold'>
                                        <td className="fw-600">{TranslateString('Total')}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.loan_value_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.price_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.quartile_25_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.quartile_75_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.ltv_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.ltv_min_total}</td>
                                        <td className="text-right text-nowrap fw-600">{props?.tableData?.loanData_total?.ltv_max_total}</td>

                                    </tr>
                                    : ""}
                            </tfoot>
                        </table>
                    </div>
                    <Row>
                        <Col sm={8}>
                            <div ref={targetRef}>
                                <div className='mt-3 cu-table-border'>
                                    <table className="table table-sm table-bordered table-striped " >
                                        <thead className="">
                                            <tr className="">
                                                <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                                    {TranslateString('Apartments and indicative price estimate per apartment type')}
                                                </td>
                                            </tr>
                                            <tr className='cu-bg-green align-top cu-text-small text-left'>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Area')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Amount of apartments')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average eur/m2')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average indicative price estimate')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative price estimate(lower quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative price estimate(upper quartile)')}</th>
                                            </tr>
                                        </thead>
                                        
                                        <tfoot>
                                            {props?.tableData?.apartment_data?.length > 0 || props?.tableData?.apartment_total ?
                                                <tr className='cu-text-small text-left fw-bold'>
                                                    <td className='text-right text-nowrap fw-600'>{props?.tableData?.apartment_total?.total_surface}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.apartment_total?.no_apartments_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.apartment_total?.price_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.apartment_total?.indicative_price_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.apartment_total?.quartile_25_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.apartment_total?.quartile_75_total}</td>
                                                </tr>
                                                : ""}
                                        </tfoot>
                                    </table>
                                </div>
                                <div className='mt-3 cu-table-border'>
                                    <table className="table table-sm table-bordered table-striped " >
                                        <thead className="">
                                            <tr className="">
                                                <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                                    {TranslateString('Car spaces and indicative price estimate')}
                                                </td>
                                            </tr>
                                            <tr className='cu-bg-green align-top cu-text-small text-left'>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Amount of car spaces')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average debt-free price')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average indicative value')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative value (lower quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative value (upper quartile)')}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {props?.tableData?.car_space_data ?
                                                <tr className='cu-text-small text-left'>
                                                    <td className="text-right">{props?.tableData?.car_space_data.car_space_amt}</td>
                                                    <td className="text-right">{props?.tableData?.car_space_data.avg_price}</td>
                                                    <td className="text-right">{props?.tableData?.car_space_data.indicative_price}</td>
                                                    <td className="text-right">{props?.tableData?.car_space_data.quartile_25}</td>
                                                    <td className="text-right">{props?.tableData?.car_space_data.quartile_75}</td>
                                                </tr>
                                                : <tr><td colSpan={7}><Empty description={TranslateString("Empty")}/></td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='mt-3 cu-table-border'>
                                    <table className="table table-sm table-bordered table-striped " >
                                        <thead className="">
                                            <tr className="">
                                                <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                                    {TranslateString('Business spaces and indicative price estimate')}
                                                </td>
                                            </tr>
                                            <tr className='cu-bg-green align-top cu-text-small text-left'>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Amount of business spaces')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('m2')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average eur/m2')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average indicative value')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative value (lower quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Indicative value (upper quartile)')}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {props?.tableData?.car_space_data ?
                                                <tr className='cu-text-small text-left'>
                                                    <td className="text-right">{props?.tableData?.business_space_data.business_space_amt}</td>
                                                    <td className="text-right">{props?.tableData?.business_space_data.surface_area}</td>
                                                    <td className="text-right">{props?.tableData?.business_space_data.avg_price}</td>
                                                    <td className="text-right">{props?.tableData?.business_space_data.indicative_price}</td>
                                                    <td className="text-right">{props?.tableData?.business_space_data.quartile_25}</td>
                                                    <td className="text-right">{props?.tableData?.business_space_data.quartile_75}</td>
                                                </tr>
                                                : <tr><td colSpan={7}><Empty description={TranslateString("Empty")}/></td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='mt-3 cu-table-border' >
                                    <table className="table table-sm table-bordered table-striped " >
                                        <thead className="">
                                            <tr className="">
                                                <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                                    {TranslateString('HSP - Sold apartments')}
                                                </td>
                                            </tr>
                                            <tr className='cu-bg-green align-top cu-text-small text-left'>
                                                <th scope="col" className="fw-600">{TranslateString('Apartment type')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Number of rooms')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average eur/m2 ka')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('eur/m2 (lower quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('eur/m2 (upper quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Number of sold apartments')}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {props?.tableData?.hsp_sales_data?.length > 0 ? props?.tableData?.hsp_sales_data?.map((val: any) => {
                                                return (
                                                    <tr className='cu-text-small text-left' key={Math.random()}>
                                                        <td >{val.sale_data_property_type}</td>
                                                        <td className="text-right">{val.sale_data_num_rooms}</td>
                                                        <td className="text-right">{val.price}</td>
                                                        <td className="text-right">{val.quartile_25}</td>
                                                        <td className="text-right">{val.quartile_75}</td>
                                                        <td className="text-right">{val.no_apartments}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={7}><Empty description={TranslateString('Empty')} /></td></tr>}
                                        </tbody>
                                        <tfoot>
                                            {props?.tableData?.hsp_sales_data?.length > 0 && props?.tableData?.hsp_sales_total ?
                                                <tr className='cu-text-small text-left fw-bold'>
                                                    <td className="fw-600">{TranslateString('Total')}</td>
                                                    <td></td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_total?.price_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_total?.quartile_25_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_total?.quartile_75_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_total?.no_apartments_total}</td>
                                                </tr> : ""}
                                        </tfoot>
                                    </table>
                                </div>
                                <div className='mt-3 cu-table-border' >
                                    <table className="table table-sm table-bordered table-striped " >
                                        <thead className="">
                                            <tr className="">
                                                <td colSpan={8} className='text-left cu-text-large fw-bold'>
                                                    {TranslateString('HSP - Sold car spaces')}
                                                </td>
                                            </tr>
                                            <tr className='cu-bg-green align-top cu-text-small text-left'>
                                                <th scope="col">{TranslateString('Type')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Average debt-free price')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Debt-free price(lower quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Debt-free price(upper quartile)')}</th>
                                                <th scope="col" className="text-right fw-600">{TranslateString('Amount of sold car spaces')}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {props?.tableData?.hsp_sales_car_data?.length > 0 ? props?.tableData?.hsp_sales_car_data?.map((val: any) => {
                                                return (
                                                    <tr className='cu-text-small text-left' key={Math.random()}>
                                                        <td >{val.sale_data_property_type}</td>
                                                        <td className="text-right">{val.price}</td>
                                                        <td className="text-right">{val.quartile_25}</td>
                                                        <td className="text-right">{val.quartile_75}</td>
                                                        <td className="text-right">{val.no_apartments}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={7}><Empty description={TranslateString('Empty')} /></td></tr>}
                                        </tbody>
                                        <tfoot>
                                            {props?.tableData?.hsp_sales_car_data?.length > 0 && props?.tableData?.hsp_sales_car_total ?
                                                <tr className='cu-text-small text-left fw-bold'>
                                                    <td className="fw-600">{TranslateString('Total')}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_car_total?.price_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_car_total?.quartile_25_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_car_total?.quartile_75_total}</td>
                                                    <td className="text-right text-nowrap fw-600">{props?.tableData?.hsp_sales_car_total?.no_apartments_total}</td>
                                                </tr>
                                                : ""}
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className='mb-3 w-100 text-left'>
                                {/* <label>Katu</label>
                                <Select
                                    placeholder="Select"
                                    className="w-100"
                                    allowClear
                                    loading
                                    options={[
                                        {
                                            value: 'jack',
                                            label: 'Jack',
                                        },
                                        {
                                            value: 'lucy',
                                            label: 'Lucy',
                                        },
                                        {
                                            value: 'disabled',
                                            disabled: true,
                                            label: 'Disabled',
                                        },
                                        {
                                            value: 'Yiminghe',
                                            label: 'yiminghe',
                                        },
                                    ]}
                                /> */}
                            </div>
                            <div className="card card-body rounded-0  d-flex align-items-center border border-dark p-0" style={{ height: dimensions?.height + 'px' }}>
                                <CustomMap
                                    height={dimensions?.height}
                                    locations={locationData}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Col>
        </>
    );
};
export default React.memo(ExtLtvTableCard);